import React, {useCallback} from "react";
import {FIELDS_FRAMES} from "../../constants/admin-fields";
import {Col, Row} from "reactstrap";
import {Table, Tbody, Thead} from "../../new-components/admin/table";
import {Button} from "reactstrap";
import PageHeader from "../../new-components/admin/page-header";
import useFrameCRUD from "../../hooks/useFrameCRUD";
import TRowBody from "../../new-components/admin/table/TRowBody";
import TBodyDraggable from "../../new-components/admin/table/TBodyDraggable";
import {debounce} from "debounce";
import axios from "axios";
import {reorder} from "../../helpers";

const token = localStorage.getItem("authToken");
const OPTIONS_TBODY = {
    input: {
        price: "number",
        frameWidth: "number",
        pieceLength: "number",
        rabbetWidth: "number",
        isInStock: "boolean",
    },
};

const styledButton = {
    margin: "20px",
};

const EditFrames = () => {
    const [frames, events] = useFrameCRUD();

    const deleteFrame = async (id) => {
        const doYouAgree = window.confirm("Are you sure you want to delete this?");
        if (doYouAgree) {
            await events.fetchDeleteFrame(id);
        }
    };


    const debounceChangeField = useCallback(
        debounce(events.updateFrameField, 300),
        [frames]
    );

    const updateFramesOrderSort = async (soringFrames) => {
        const formatSorting = soringFrames.map(({_id, orderSort}) => ({
            _id,
            orderSort,
        }));
        await axios.put(
            "api/admin-settings/frames/order-sort",
            {formatSorting},
            {headers: {Authorization: `Token ${token}`}}
        );
    };

    const orderSortFrames = async (result) => {
        const items = reorder(
            frames,
            result.source.index,
            result.destination.index
        );


        const soringFrames = items.map((frame, index) => ({
            ...frame,
            orderSort: index,
        }));

        events.setFrames(soringFrames);
        updateFramesOrderSort(soringFrames).then();
    };

    return (
        <div className="admin-container main-container">
            <PageHeader
                title="Frames"
            />
            <Row data-overflow="true">
                <Col>
                    <Table className="priceDefinitionTable">
                        <Thead
                            columns={FIELDS_FRAMES}
                            columnDelete={true}
                            columnUploadImages={true}
                        />
                        <TBodyDraggable
                            onDragEnd={orderSortFrames}
                            tBodyProps={{
                                columns: Object.keys(FIELDS_FRAMES),
                                rows: frames,
                                optionsRow: OPTIONS_TBODY,
                                columnDelete: true,
                                columnUploadImages: true,
                                onDeleteRow: deleteFrame,
                                onChangeFieldColumn: debounceChangeField,
                                componentsRows: TRowBody,
                            }}
                        />
                    </Table>
                    <Button style={styledButton} onClick={events.fetchAddFrame}>
                        Add
                    </Button>
                </Col>
            </Row>
        </div>
    );
};

export default EditFrames;



// WEBPACK FOOTER //
// ./src/page/admin/edit-frames.js